import { ChartOptionsProvider } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class HistoricEbitYearThreeRatioOptionsProvider extends ChartOptionsProvider {
  getOptions(company) {
    if (!company.historic_ebitmargin_expectation || !company.historic_ebitmargin_year_three) {
      return;
    }
    const historicImpliedEbitMargin = company.historic_ebitmargin_expectation.filter(item => (item.date && typeof item.value == 'number' && item.value !== null));
    const historicYearThreeEbitMargin = company.historic_ebitmargin_year_three.filter(item => (item.date && typeof item.value == 'number' && item.value !== null));
    const historicYearThreeRevenueGrowth = company.historic_year_three_revenue_growth ? company.historic_year_three_revenue_growth.filter(item => (item.date && typeof item.value == 'number')) : [];

    const impliedOverY3e = historicImpliedEbitMargin.map(implied => {
      const matchingYearThree = historicYearThreeEbitMargin.find(yearThree => yearThree.date == implied.date);
      if (matchingYearThree) {
        return {
          date: implied.date,
          value: parseFloat(implied.value) / parseFloat(matchingYearThree.value)
        }
      }
    }).filter(item => item);

    const ebitMarginExpectation = company.platformData.ebitMarginExpectation;
    const yearThree = company.platformData.ebitMarginData.yearThree;
    const yearThreeRevenueGrowth = company.platformData.companyAnalysis.yearThreeConsensusGrowth;
    const currentDate = new Date();
    currentDate.setHours(1,0,0,0);
    const currentImpliedOverY3e = ebitMarginExpectation/yearThree;

    let chartOptions = {
      chart: Object.assign(this.defaultChartOptions.chart,{spacingBottom: 70}),
      title: 'Historic Implied EBIT Margin / Year 3 consensus estimate (%)',
      
      legend: this.defaultChartOptions.legend,
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          year: '%Y'
        }
      },
      yAxis: [{
        labels:{
            x:0
        },
        min: Math.min(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) - 2,
        max: Math.max(...impliedOverY3e.map(item => 100 * (parseFloat(item.value)))) + 2,
        minTickInterval: 1,
        title: {
          text: null
        }
      },
      {
        labels:{
            x:0
        },
        min: Math.min(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) - 2,
        max: Math.max(...historicYearThreeRevenueGrowth.map(item => 100 * (parseFloat(item.value)))) + 2,
        minTickInterval: 1,
        title: {
          text:  null
        },
        opposite: true
      }],
      tooltip: this.defaultChartOptions.tooltip,
      series: [Object.assign({}, this.defaultChartOptions.series[0],
        {
          name: 'Historic Implied EBIT Margin/Y3e (%)',
          negativeColor: 'rgba(255,0,0,0.6)',
          data: [...impliedOverY3e.map(item => [new Date(item.date).getTime(), 100 * parseFloat(item.value)]), [currentDate.getTime(), 100 * currentImpliedOverY3e] ],
          marker: {
            enabled: false
          },
          visible: true,
          yAxis: 0
        }),
      
        {
          name: 'y3e Revenue Growth',
          data: [...historicYearThreeRevenueGrowth.map(item => [new Date(item.date).getTime(), 100 * parseFloat(item.value)]), [currentDate.getTime(), yearThreeRevenueGrowth*100]],
          marker: {
            enabled: false
          },
          visible: true,
          yAxis: 1
        },
      ]
    }
    chartOptions = this.setYMax(chartOptions);
    chartOptions = this.setYMin(chartOptions);
    return super.getOptions(company, chartOptions);
  };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/historic-ebit-year-three-ratio.ts